(function () {
  angular
    .module('kareo.ui.shared.directives.validation.k-valid-npi', [
      'kareo.ui.shared.modules.api.k-npi-service'
    ])
    .directive('kValidNpi', kValidNpi);

  kValidNpi.$inject = ['kNpiService'];

  function kValidNpi(kNpiService) {
    return {
      link,
      require: 'ngModel'
    };

    function link(scope, elem, attr, ngModel) {
      elem.attr('maxlength', 10);
      ngModel.$validators.npi = function validateNpi(modelValue, viewValue) {
        return ngModel.$isEmpty(viewValue) || kNpiService.isValidNPI(viewValue);
      };
    }
  }
})();
